import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { formatDateTime } from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import {
  BinIcon1,
  CallIcon,
  CallIcon1,
  EditIcon1,
  EyeIcon,
  SendIcon,
  WhatsAppIconIcon,
} from "../../../images/icons/icons";

const LeadLogAccordianIndo = ({
  rowData,
  setClickValues,
  handleDelete,
  isLeadLoading,
  userInfoData,
  isMarketing,
}) => {
  const handleWhatsAppButtonClick = (e, phoneNumber) => {
    e.preventDefault();
    window.open(`https://wa.me/+91${phoneNumber}`, "_blank");
  };

  const handleCallButtonClick = (e, phoneNumber) => {
    e.preventDefault();
    window.open(`tel:${phoneNumber}`, "_self");
  };

  const isAdmin = userInfoData?.account_type === "admin";

  return (
    <div className="all-followuo-info-container">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="heade-info">
              <span className="title">Next Followup Date</span>
              <span className="value">
                {rowData?.next_followup_date
                  ? formatDateTime(rowData.next_followup_date)
                  : "-"}
              </span>
            </div>
          </Accordion.Header>

          <Accordion.Body>
            <div className="lead-multi-value-cols px20px pb20px">
              <div className="label-value flex-col">
                <span className="label">Last Followup Status</span>
                <span className="value">
                  {rowData?.current_followup_status?.replace(/_/g, " ") || "NA"}
                  <br />({rowData?.cutomer_intent?.replace(/_/g, " ") || ""})
                </span>
              </div>

              <div className="label-value">
                <span className="label"> Followup count</span>
                <span className="value">
                  {rowData?.followup_days_count || "-"}
                </span>
              </div>

              <div className="label-value">
                <span className="label"> Lead Stage</span>
                <span className="value">{rowData?.mem_lead_stage || "NA"}</span>
              </div>

              {/* <div className="label-value">
                <span className="label">outgoing calls</span>
                <span
                  className="value link"
                  onClick={() =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: rowData,
                      cardName: "total_outgoing_call",
                    }))
                  }>
                  {rowData?.total_outgoing_call || 0}
                </span>
              </div>

              <div className="label-value">
                <span className="label">connected calls</span>
                <span
                  className="value link"
                  onClick={() =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: rowData,
                      cardName: "total_outgoing_connected_call",
                    }))
                  }>
                  {rowData?.total_outgoing_connected_call || 0}
                </span>
              </div> */}

              <div className="label-value">
                <span className="label">Converted Value</span>
                <span className="value">
                  ₹{rowData?.converted_value || 0} <br />
                  {rowData?.conversion_date
                    ? formatDateTime(rowData.conversion_date)
                    : ""}
                </span>
              </div>
              <div className="label-value">
                <span className="label">Lead Status</span>
                <span className="value">
                  {" "}
                  {rowData?.lead_status === "pending"
                    ? "Upcoming Followup"
                    : rowData?.lead_status || "NA"}
                </span>
              </div>
              <div className="label-value">
                <span className="label">Source Name</span>
                <span className="value">
                  {rowData?.source_name?.replace(/_/g, " ") || "NA"}
                </span>
              </div>
              <div className="label-value flex-col">
                <span className="label">Added By</span>
                <span className="value">{rowData?.added_by_name || "NA"}</span>
              </div>
              <div className="label-value flex-col">
                <span className="label">Assign To</span>
                <span className="value">
                  {rowData?.assigned_to_name || "NA"}
                </span>
              </div>
              <div className="label-value flex-col">
                <span className="label">Date Added</span>
                <span className="value">
                  {rowData?.date_added
                    ? formatDateTime(rowData.date_added)
                    : "-"}
                </span>
              </div>
              <div className="label-value flex-col">
                <span className="label">Lead From</span>
                <span className="value">
                  {rowData?.lead_from === "lms" ||
                  rowData?.lead_from === "direct"
                    ? "LMS (Directly Added From LMS)"
                    : rowData?.lead_from === "expiring"
                    ? "Renewal (Renewal and Expiring Members)"
                    : rowData?.lead_from === "recurring"
                    ? "Recurring (Recurring Members)"
                    : rowData?.lead_from === "one_time_link"
                    ? "One Time Payment Link"
                    : rowData?.lead_from === "raw_lead"
                    ? "RLMS (Raw Leads)"
                    : rowData?.lead_from === "unpaid"
                    ? "Unpaid (Unpaid Members)"
                    : rowData?.lead_from?.replace(/_/g, " ") || "NA"}
                </span>
              </div>
              <div className="label-value flex-col">
                <span className="label">call activity</span>
                <span
                  className="value link"
                  onClick={() =>
                    setClickValues({
                      isModOpen: true,
                      modName: "total_outgoing_call",
                      rowData: rowData,
                    })
                  }
                >
                  {rowData?.total_outgoing_call || 0} calls made
                </span>
              </div>
              <div className="label-value flex-col">
                <span className="label">call activity</span>
                <span
                  className="value link"
                  onClick={() =>
                    setClickValues({
                      isModOpen: true,
                      modName: "total_outgoing_connected_call",
                      rowData: rowData,
                    })
                  }
                >
                  {rowData?.total_outgoing_connected_call || 0} connected
                </span>
              </div>
            </div>

            <div className="all-btns lead-btn-axceed">
              {!isMarketing && (
                <div className="lead-log-box">
                  <button
                    className="lead-log call-btn"
                    onClick={(e) => handleCallButtonClick(e, rowData?.mobile)}
                  >
                    <CallIcon1 color="white" />
                  </button>

                  <span className="btn-label">Call lead</span>
                </div>
              )}

              {!isMarketing && (
                <div
                  className="lead-log-box"
                  onClick={(e) => handleWhatsAppButtonClick(e, rowData?.mobile)}
                >
                  <button className="lead-log whatsapp-btn">
                    <WhatsAppIconIcon />
                  </button>

                  <span className="btn-label">WhatsApp</span>
                </div>
              )}

              <div className="lead-log-box">
                <button
                  className="lead-log view-lead"
                  onClick={() =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: rowData,
                      cardName: "follow-up",
                      modName: "view",
                    }))
                  }
                >
                  <EyeIcon />
                </button>

                <span className="btn-label">View Lead</span>
              </div>

              <div className="lead-log-box">
                <button
                  className="lead-log click-to-call"
                  onClick={() =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: rowData,
                      modName: "click-to-call",
                    }))
                  }
                >
                  <CallIcon />
                </button>

                <span className="btn-label">click to call</span>
              </div>

              <div className="lead-log-box">
                <button
                  className="lead-log pm-link"
                  onClick={() =>
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: rowData,
                      modName: "send-payment-link",
                    }))
                  }
                >
                  <SendIcon />
                </button>

                <span className="btn-label">payment link</span>
              </div>

              {!isMarketing && (
                <div className="lead-log-box">
                  <button
                    className="lead-log edit-btn"
                    disabled={
                      rowData?.lead_status?.toLowerCase() === "closed" ||
                      rowData?.lead_status?.toLowerCase() === "converted"
                    }
                    style={{
                      cursor:
                        rowData?.lead_status?.toLowerCase() === "closed" ||
                        rowData?.lead_status?.toLowerCase() === "converted"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={() =>
                      setClickValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        rowData: rowData,
                        cardName: "edit",
                        modName: "edit",
                      }))
                    }
                  >
                    <EditIcon1 />
                  </button>

                  <span className="btn-label">Edit</span>
                </div>
              )}

              {isAdmin ? (
                <div className="lead-log-box">
                  <button
                    className="lead-log delete-btn"
                    disabled={
                      rowData?.lead_status?.toLowerCase() === "closed" ||
                      rowData?.lead_status?.toLowerCase() === "converted"
                    }
                    style={{
                      cursor:
                        rowData?.lead_status?.toLowerCase() === "closed" ||
                        rowData?.lead_status?.toLowerCase() === "converted"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={(e) => {
                      const payload = {
                        lead_id: rowData?.lead_id,
                        status: "deleted",
                      };
                      handleDelete(payload);
                    }}
                  >
                    {isLeadLoading ? <Loader /> : <BinIcon1 />}
                  </button>

                  <span className="btn-label">delete</span>
                </div>
              ) : null}

              {/* <div className="lead-log-box">
                <button
                  className="lead-log delete-btn"
                  disabled={!rowData?.wap_image}
                  style={{
                    cursor: rowData?.wap_image ? "pointer" : "not-allowed",
                    opacity: rowData?.wap_image ? 1 : 0.5,
                  }}
                  onClick={
                    rowData?.wap_image
                      ? () =>
                          setClickValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            rowData: rowData,
                            cardName: "wap_image",
                          }))
                      : null
                  }
                >
                  <BiImageIcon />
                </button>

                <span className="btn-label">Whatsapp Intro</span>
              </div> */}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default LeadLogAccordianIndo;
